export const mutations = {
    STORE_SYSTEM_ROLES(state, roles) {
       state.roles = roles
    },
    STORE_ROLE_UPDATE(state, roleid) {
        let Role = state.roles.find(function(role){
            return role.id === roleid
        })
        state.systemRole = Role
    }
}
export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/roles/mutations.js